module.exports = __webpack_public_path__ + "img/icon_1_47.d12781a5.png";